<template>
  <div>
    <div>
      <v-data-table
        :headers="headers"
        :items="attachments"
        :page.sync="pagination.page"
        :items-per-page="pagination.rowsPerPage"
        :items-per-page-text="rowsPerPageText"
        :items-per-page-items="rowsPerPageItems"
        :header-props="{ sortIcon }"
        :footer-props="{ prevIcon, nextIcon }"
        class="elevation-2"
      >
        <template v-slot:item="props">
          <tr @click="viewItem(props.item)" :class="{ 'cursor-pointer': true }">
            <td>{{ props.item.name }}</td>

            <td v-if="!commentID">
              {{ props.item.objBelongingId }}
            </td>

            <td>
              <app-datatable-action-buttons
                :user-can-delete="true"
                @delete="askConfirmationToDeleteItem(props.item)"
                :user-can-edit="false"
              />
            </td>
          </tr>
        </template>

        <template v-slot:pageText="props">
          {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
          {{ props.itemsLength }}
        </template>
      </v-data-table>
      <app-dialog-box
        :open="deleteDialog"
        :title="$t('DeleteAttachment')"
        :content="$t('DeleteConfirmation') + ' ' + itemToDelete.name + '?'"
        :main-action-label="$t('No')"
        @mainAction="cancelDelete"
        :secondary-action-label="$t('Yes')"
        @secondaryAction="deleteAttachment(itemToDelete.id)"
        :loading="loadingDelete"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";

export default {
  name: "AttachmentsTable",

  components: {
    AppDatatableActionButtons,
    AppDialogBox
  },

  mixins: [managementDatatableMixin, checkPermissionsMixin],

  props: {
    attachments: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      loadingDelete: false,
      pagination: {
        sortBy: "objBelongingId",
        descending: true
      }
    };
  },

  computed: {
    ticketID() {
      return this.$route.params.id;
    },

    commentID() {
      let id = this.$route.params.commentId;
      if (id) {
        return id;
      }
    },

    actionType() {
      let routeName = this.$route.name;
      if (routeName === "comments-edit" || routeName === "tickets-edit") {
        return "edit";
      } else if (
        routeName === "comments-create" ||
        routeName === "tickets-create"
      ) {
        return "create";
      }
    },

    mainHeaders() {
      let tabs = [
        {
          text: this.$i18n.t("Name"),
          value: "name",
          width: "50%"
        }
      ];
      if (!this.commentID) {
        tabs.push({
          text: this.$i18n.t("RespectiveCommentID"),
          value: "objBelongingId",
          width: "50%"
        });
      }
      return tabs;
    }
  },

  methods: {
    ...mapActions([
      "deleteTicketAttachmentByID",
      "deleteCommentAttachmentByID"
    ]),

    viewItem(attachment) {
      this.$emit("open-attachment", attachment);
    },

    async deleteAttachment(attachmentID) {
      if (this.actionType === "create") {
        this.$emit("remove-attachment", this.findAttachmentIndex(attachmentID));
      }
      try {
        this.loadingDelete = true;
        if (this.commentID === undefined && this.ticketID) {
          await this.deleteTicketAttachmentByID({
            ticketID: this.ticketID,
            attachmentID: attachmentID
          });
        } else if (this.ticketID && this.commentID) {
          await this.deleteCommentAttachmentByID({
            ticketID: this.ticketID,
            commentID: this.commentID,
            attachmentID: attachmentID
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.$emit("reload-ticket");
        this.deleteDialog = false;
        this.loadingDelete = false;
      }
    },

    findAttachmentIndex(id) {
      return this.attachments.findIndex(attachment => attachment.id === id);
    },

    askConfirmationToDeleteItem(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Support/TechnicalSupport/AttachmentsTable.vue